class ReviewsSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.modalController = null;
  }

  connectedCallback() {
    this.initModal();

    const swiperEl = this.querySelector('.section-reviews-slider');
    if (!swiperEl) return;

    // Initialize Swiper
    this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.2,
        spaceBetween: 24,
        breakpoints: {
          768: { slidesPerView: 1.3,spaceBetween: 24, },
          989: { slidesPerView: 1.57,spaceBetween: 40, }
        },
        pagination: {
          el: '.reviews-pagination',
          clickable: true,
        },

        navigation: {
          nextEl: '.reviews-next',
          prevEl: '.reviews-prev',
        },
    });
  }

  initModal() {
    if (typeof window.ReviewModalController !== 'function') return;

    const sectionRoot = this.closest('[id^="shopify-section-"]') || document;
    const modalSelector = this.dataset.modalSelector;
    const closeSelector = this.dataset.modalCloseSelector;

    if (!modalSelector || !closeSelector) return;

    this.modalController = new window.ReviewModalController({
      root: sectionRoot,
      triggerSelector: '.section-reviews-link--modal',
      modalSelector,
      closeSelector,
      openClass: 'is-open',
    });

    this.modalController.init();
  }

  disconnectedCallback() {
    if (this.modalController) {
      this.modalController.destroy();
      this.modalController = null;
    }

    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('reviews-slider', ReviewsSlider);